import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AddRedeemBrandCoupon from "../../../components/SuperAdmin/RedeemBrandCoupon/AddRedeemBrandCoupon";

export default withRouter(connect()(AddRedeemBrandCoupon));
